(function() {
  'use strict';

  const ANGLERBEAM_HANDLE = '/products/anglerbeam-fishing-car-door-lights';
  const ANGLERBEAM_DESIGN_IMAGES = {
    'American Bass': 'https://cdn.shopify.com/s/files/1/0754/2410/4673/files/anglerbeam-clean-01-american-bass.png?v=1791669731',
    'Leaping Bass': 'https://cdn.shopify.com/s/files/1/0754/2410/4673/files/anglerbeam-clean-02-leaping-bass.png?v=1791669734',
    'Father & Son Sunset': 'https://cdn.shopify.com/s/files/1/0754/2410/4673/files/anglerbeam-clean-03-father-and-son-sunset.png?v=1791669737',
    'Dawn Trophy Bass': 'https://cdn.shopify.com/s/files/1/0754/2410/4673/files/anglerbeam-clean-04-dawn-trophy-bass.png?v=1791669740',
    'Mountain Fly Fisher': 'https://cdn.shopify.com/s/files/1/0754/2410/4673/files/anglerbeam-clean-05-mountain-fly-fisher.png?v=1791669744'
  };

  function isAnglerBeamProduct() {
    return window.location.pathname.indexOf(ANGLERBEAM_HANDLE) !== -1;
  }

  function getAnglerBeamDesignImage(designName) {
    if (!isAnglerBeamProduct()) return null;
    return ANGLERBEAM_DESIGN_IMAGES[designName] || null;
  }

  function updateSelectorItemImage(selectorItem, variant) {
    const imageElement = selectorItem.querySelector('.quantity-break__selector-item__image img');
    if (!imageElement || !variant) return;

    const designName = variant.option1 || (variant.options && variant.options[0]) || variant.title;
    const designImage = getAnglerBeamDesignImage(designName);
    if (designImage) {
      imageElement.src = designImage;
      imageElement.alt = designName + ' design';
      return;
    }

    if (variant.featured_image && variant.featured_image.src) {
      imageElement.src = variant.featured_image.src;
      imageElement.alt = variant.featured_image.alt || '';
    }
  }

  function initializeSelectorItemImages() {
    if (!isAnglerBeamProduct()) return;
    document.querySelectorAll('.quantity-break__selector-item').forEach(selectorItem => {
      const designSelect = selectorItem.querySelector('select');
      const imageElement = selectorItem.querySelector('.quantity-break__selector-item__image img');
      const designImage = designSelect && getAnglerBeamDesignImage(designSelect.value);
      if (imageElement && designImage) {
        imageElement.src = designImage;
        imageElement.alt = designSelect.value + ' design';
      }
    });
  }

  function updateAllQuantityBreakImages(sectionId, currentVariant) {
    const quantityBreaks = document.getElementById('quantity-breaks-' + sectionId);
    if (quantityBreaks && currentVariant) {
      quantityBreaks.querySelectorAll('.quantity-break__selector-item').forEach(selectorItem => {
        updateSelectorItemImage(selectorItem, currentVariant);
      });
    }
  }

  document.addEventListener('change', function(event) {
    const selectorItem = event.target.closest('.quantity-break__selector-item');
    if (selectorItem) {
      const quantityBreaks = selectorItem.closest('quantity-breaks');
      if (quantityBreaks) {
        const variantData = quantityBreaks.getVariantData();
        const selectedValues = Array.from(selectorItem.querySelectorAll('select'), select => select.value);
        const variant = variantData.find(v => {
          return !v.options.map((option, index) => selectedValues[index] === option).includes(false);
        });
        if (variant) updateSelectorItemImage(selectorItem, variant);
      }
    }
  });

  document.addEventListener('change', function(event) {
    const variantSelects = event.target.closest('variant-selects');
    if (variantSelects) {
      const sectionId = variantSelects.dataset.section;
      const quantityBreaks = document.getElementById('quantity-breaks-' + sectionId);
      if (quantityBreaks) {
        setTimeout(() => {
          const currentVariant = variantSelects.currentVariant;
          if (currentVariant) updateAllQuantityBreakImages(sectionId, currentVariant);
        }, 100);
      }
    }
  });

  document.addEventListener('variantChange', function(event) {
    if (event.detail && event.detail.variant && event.detail.sectionId) {
      updateAllQuantityBreakImages(event.detail.sectionId, event.detail.variant);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeSelectorItemImages);
  } else {
    initializeSelectorItemImages();
  }
})();